import { TNM } from "./NodeMaker.js";
import { BufferToDBO } from "./DBO/BufferToDBO.js";
import { ObjectToBuffer } from "./DBO/ObjectToBuffer.js";
import { DBOToBuffer } from "./DBO/DBOToBuffer.js";
export const DBO = {
    nodes: TNM,
    bufferToObject(buffer, byteOffSet = 0) {
        return BufferToDBO.toObject(buffer);
    },
    objectToBuffer(obj) {
        return ObjectToBuffer.toBuffer(obj);
    },
    objectToDBO(object) {
        return ObjectToBuffer.toDBO(object);
    },
    dboToBuffer(data) {
        return DBOToBuffer.toBuffer(data);
    },
    bufferToDBO(buffer, byteOffSet = 0, byteOffSetEnd = 0) {
        return BufferToDBO.toDBO(buffer, byteOffSet, byteOffSetEnd);
    },
};
